export const initialQuestionIds: Record<string, string> = {
  INTERLOCUTER: 'INTERLOCUTER',
  NAME: 'NAME',
  DATE_OF_BIRTH: 'DATE_OF_BIRTH',
  SEX: 'SEX',
  CONSULTATION_DATE: 'CONSULTATION_DATE',
  CONSULTATION_TIME: 'CONSULTATION_TIME',
  // Semi-controlled: answered by the patient-profession onboarding page, not
  // asked in the questionnaire.
  PROFESSION: 'PROFESSION',
};

export const responseIds = {
  INTERLOCUTER: {
    SELF: 'INTERLOCUTER-SELF',
    OTHER: 'INTERLOCUTER-OTHER',
  },
  NAME: {
    FIRST_NAME: 'NAME-FIRST_NAME',
    LAST_NAME: 'NAME-LAST_NAME',
  },
  DATE_OF_BIRTH: 'DATE_OF_BIRTH-DATE_OF_BIRTH',
  SEX: {
    MALE: 'SEX-MALE',
    FEMALE: 'SEX-FEMALE',
  },
  CONSULTATION_DATE: 'CONSULTATION_DATE-CONSULTATION_DATE',
  CONSULTATION_TIME: 'CONSULTATION_TIME-CONSULTATION_TIME',
  PROFESSION: 'PROFESSION-PROFESSION',
};

export const patientResponseIds = [
  responseIds.INTERLOCUTER.SELF,
  responseIds.INTERLOCUTER.OTHER,
  responseIds.NAME.FIRST_NAME,
  responseIds.NAME.LAST_NAME,
  responseIds.DATE_OF_BIRTH,
  responseIds.SEX.MALE,
  responseIds.SEX.FEMALE,
];

export const consultationResponseIds = [
  responseIds.CONSULTATION_DATE,
  responseIds.CONSULTATION_TIME,
];

/**
 * Reserved classification prefix for "calculated responses" (ALDO-2256):
 * report spans that never appear in the medical report and are instead
 * referenced by classification inside another span's `questionnaire` list,
 * rendering alongside patient answers in the pro score-detail modal.
 */
export const CALCULATED_RESPONSE_PREFIX = 'CR.';

export const isCalculatedResponse = (classification?: string | null): boolean =>
  !!classification?.startsWith(CALCULATED_RESPONSE_PREFIX);
